var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.335,
    cy: 18.335,
    r: 18.335,
    fill: "url(#paint0_linear_5660_63735)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5457 22.7164C18.2265 22.7164 17.9745 22.6156 17.7897 22.414C17.6217 22.2124 17.5209 21.9268 17.4873 21.5572L16.7313 11.9308C16.6809 11.3092 16.8153 10.8136 17.1345 10.444C17.4537 10.0576 17.9241 9.86443 18.5457 9.86443C19.1505 9.86443 19.6041 10.0576 19.9065 10.444C20.2257 10.8136 20.3601 11.3092 20.3097 11.9308L19.5537 21.5572C19.5369 21.9268 19.4361 22.2124 19.2513 22.414C19.0833 22.6156 18.8481 22.7164 18.5457 22.7164ZM18.5457 27.958C17.9745 27.958 17.5125 27.7816 17.1597 27.4288C16.8237 27.076 16.6557 26.6224 16.6557 26.068C16.6557 25.5304 16.8237 25.0936 17.1597 24.7576C17.5125 24.4048 17.9745 24.2284 18.5457 24.2284C19.1337 24.2284 19.5873 24.4048 19.9065 24.7576C20.2425 25.0936 20.4105 25.5304 20.4105 26.068C20.4105 26.6224 20.2425 27.076 19.9065 27.4288C19.5873 27.7816 19.1337 27.958 18.5457 27.958Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5660_63735",
    x1: 18.335,
    y1: 0,
    x2: 18.335,
    y2: 36.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAA00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.944063e9ecaad0bf6a67741c91954d60.svg";
export { ForwardRef as ReactComponent };